'use client'

import { usePathname, useRouter } from 'next/navigation'
import React, { useRef, useTransition } from 'react'

import styles from './auth.module.css'

// Search field of the institution picker. A plain GET form (works without JavaScript); with JavaScript the results
// follow the typing (the server page re-renders them, the list of 300+ institutions never goes to the browser).
export function InstitutionSearch({
  initialQuery,
  next,
  labels,
}: {
  initialQuery: string
  next?: string
  labels: { searchLabel: string; searchPlaceholder: string; search: string }
}) {
  const router = useRouter()
  const pathname = usePathname()
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)
  const [pending, startTransition] = useTransition()

  const onInput = (event: React.FormEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value
    if (timer.current) clearTimeout(timer.current)
    timer.current = setTimeout(() => {
      const params = new URLSearchParams({ ...(value.trim() ? { q: value } : {}), ...(next ? { next } : {}) })
      startTransition(() => router.replace(params.size ? `${pathname}?${params}` : pathname, { scroll: false }))
    }, 250)
  }

  return (
    <form role="search" method="get" className={styles.form} data-testid="institution-form">
      <div className={styles.field}>
        <label htmlFor="institution-q" className={styles.label}>
          {labels.searchLabel}
        </label>
        <div className={styles.searchRow}>
          <input
            id="institution-q"
            name="q"
            type="search"
            className={styles.input}
            defaultValue={initialQuery}
            placeholder={labels.searchPlaceholder}
            autoComplete="off"
            spellCheck={false}
            onInput={onInput}
            aria-busy={pending}
            data-testid="institution-search"
          />
          <button type="submit" className="btn btn-primary">
            {labels.search}
          </button>
        </div>
      </div>
      {next && <input type="hidden" name="next" value={next} />}
    </form>
  )
}
